import { useRequiredContext } from "@redotech/react-util/context";
import { createContext } from "react";
import type { GlobalSupportTicketCollections } from "../db/collections";

export const GlobalSupportTicketCollectionsContext = createContext<
  GlobalSupportTicketCollections | undefined
>(undefined);
GlobalSupportTicketCollectionsContext.displayName =
  "GlobalSupportTicketCollectionsContext";

export function useGlobalSupportTicketCollections(): GlobalSupportTicketCollections {
  return useRequiredContext(GlobalSupportTicketCollectionsContext);
}
